import React, { useRef, useEffect } from 'react'
import { Modal } from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import SosPic from '../../../../assets/images/sos.png';
// import ChildPic from "../../../../assets/images/child-round.png";
import moment from 'moment';
import useKidListFunctionality from '../../../customHooks/kidListHook';

const SosFromChild = ({ showModal, closeModal, dashData, getLangTranslation }) => {
    const { getImage } = useKidListFunctionality();
    const modalRef = useRef();
    useEffect(() => {
        if (showModal) {
            const modal = new Modal(modalRef.current, {
                backdrop: 'static',
                keyboard: false,
            });
            modal.show();
        }
    }, [showModal]);

  return (
    <div className="modal fade" tabIndex="-1" ref={modalRef}>
        <div className="modal-dialog modal-dialog-centered modal-sm">
            <div className="modal-content">
                <div className="modal-header border-0 ">
                    <h6 className="modal-title text-blue-900">{getLangTranslation("PARENT_DASHBOARD_ALRET_SOS", "SOS from child")}</h6>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={closeModal}></button>
                </div>
                <div className="modal-body">
                    <img src={SosPic} className='d-block mx-auto' alt='' />
                    <div className='d-flex  gap-3  my-9 border rounded-3 px-2 py-3'>
                        <span className='icon-wrap icon-lg p-0 border-0 bg-transparent flex-shrink-0'>
                            <img src={getImage(dashData?.image, getImage(dashData?.gender, null))} className='w-100 rounded-circle' alt='' />
                        </span>
                        <div>
                            <h5 className=' mb-0 fw-bold'>{dashData?.childName}</h5>
                            <p className='text-small mb-1'>{getLangTranslation('CHILD_LOCATION_DEVICE', 'Device:')} {dashData?.deviceName}</p>
                            {/* <p className='text-small text-dark mb-1'>3274 Doe Meadow Drive, Annapolis Junction, MD 20701</p> */}
                            <span>{getLangTranslation('SOS_SINCE', 'Since')} {moment(dashData?.sosTime).locale('en').format('HH:mm')}</span>
                        </div>
                    </div>
                    <div className="grid gap-3 mt-6">
                        <button className="btn btn-primary g-col-6" type="button">
                            <span className="btn-upper-case">{getLangTranslation('SOS_DRIVE_NOW', 'Drive now')}</span>
                        </button>
                        <button className="btn btn-outline-primary g-col-6" type="button" data-bs-dismiss="modal" aria-label="Close" onClick={closeModal}>
                            <span className="btn-upper-case">{getLangTranslation('SOS_CLOSE', 'Close')}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default SosFromChild